import axios from 'axios'

const editCard = async (id, cardData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/updateCard/${id}`,
      cardData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      }
    )
    return response.data
  } catch (error) {
    console.error('Failed to edit card:', error)
    throw error
  }
}

export default editCard
